import { vars } from "@common/styles";
import styled from "styled-components";

export const ValueInputContainer = styled.div<{ $isError?: boolean }>`
  background-color: ${vars.colors.blackDarker};
  border: 1px solid ${({ $isError }) => ($isError ? vars.colors.red : vars.colors.grey90)};
  border-radius: 1.2rem;
  padding: 0.9rem 1.2rem;
  height: 6rem;
  transition: border-color 0.2s ease;
  gap: 0.3rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 12rem;
`;

export const ValueInputLabel = styled.label`
  display: block;
  font-size: 1.2rem;
  color: ${vars.colors.grey60};
  line-height: 1.6rem;
  margin-bottom: 0.2rem;
  font-weight: 500;
  letter-spacing: 0;
`;

export const ValueInputRow = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.3rem;
`;

export const ValueInput = styled.input<{ $isError?: boolean }>`
  background: none;
  border: none;
  outline: none;
  font-size: 1.6rem;
  font-weight: 500;
  color: ${({ $isError }) => ($isError ? vars.colors.red : vars.colors.grey30)};
  font-family: Roobert, serif;
  appearance: textfield;
  line-height: 20px;
  letter-spacing: 0;
  min-width: 0;

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const ValueInputUnit = styled.span`
  font-size: 1.6rem;
  color: ${vars.colors.grey60};
  font-family: Roobert, serif;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0;
`;
